import { GET_FAVORITES_SUCCESS, TOGGLE_FAVORITE } from "../actions";
import initialState from "./initialState";
export default function favorites() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.favorites, action = arguments.length > 1 ? arguments[1] : void 0;
    var index = state.indexOf(action.id);
    var _state = state.slice();
    switch(action.type){
        case GET_FAVORITES_SUCCESS:
            return action.favorites;
        case TOGGLE_FAVORITE:
            if (index > -1) {
                _state[index] = _state[_state.length - 1];
                _state.pop();
            } else {
                _state.push(action.id);
            }
            return _state;
        default:
            return state;
    }
}
